import { ListItem } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  setRef?: (ref: HTMLElement | null) => void;
}

export const ItemContainer = (props: PropsWithChildren<Props>) => {
  const { setRef } = props;

  return (
    <ListItem
      role="Handle"
      ref={setRef}
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "2px",
        p: 0,
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          cursor: "pointer",
        },
        position: "relative",
      })}
    >
      {props.children}
    </ListItem>
  );
};

export default ItemContainer;
